//https://stackoverflow.com/questions/5042170/clone-google-map-instance

export class MapCanvasManager {
    constructor(mainId = 'map_canvas', galleryId = 'galleryMapCanvas') {
        this.mainId = mainId;
        this.galleryId = galleryId;
        this._canvasCache = null; // für optionalen Cache
    }

    getCurrentCanvas() {
        if(this._canvasCache && document.body.contains(this._canvasCache)) {
            return this._canvasCache;
        }
        return document.getElementById(this.mainId) || document.getElementById(this.galleryId);
    }

    setCurrentCanvas(canvas) {
        this._canvasCache = canvas;
    }

    switchToGallery() {
        const main = this.getCurrentCanvas();
        if(!main) { throw new Error('Main map canvas not found!'); }

        const placeholder = document.createElement('div');
        placeholder.id = 'Map_replacement';
        main.parentNode.replaceChild(placeholder, main);

        const gallery = document.getElementById(this.galleryId);
        if(!gallery) { throw new Error('Gallery container not found!'); }

        gallery.parentNode.replaceChild(main, gallery);
        main.id = this.galleryId;

        this.setCurrentCanvas(main);

        return main;
    }

    restoreMain() {
        const gallery = this.getCurrentCanvas();
        if(!gallery) { throw new Error('Gallery map canvas not found!'); }

        const placeholder = document.createElement('div');
        placeholder.id = 'GMap_replacement';
        gallery.parentNode.replaceChild(placeholder, gallery);

        const main = document.getElementById(this.mainId) || document.getElementById('Map_replacement');

        main.parentNode.replaceChild(gallery, main);
        gallery.id = this.mainId;
        gallery.style.display = 'block';

        this.setCurrentCanvas(gallery);

        return gallery;
    }
}